import React from "react";
import { Download, Clock, Send } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

const STEP_ICONS = [Download, Clock, Send];

export const GetStarted = () => {
  const { t, tRaw } = useLanguage();
  const steps = tRaw("getstarted.steps") || [];
  return (
    <section
      id="aloita"
      data-testid="getstarted-section"
      className="relative py-24 md:py-28 bg-[#050505] border-t-2 border-[#1a1a1a]"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="text-center mb-14">
          <div className="font-mono text-[11px] tracking-[0.3em] text-[#FFEA00] uppercase mb-4">
            {t("getstarted.eyebrow")}
          </div>
          <h2 className="font-display font-bold text-white text-4xl sm:text-5xl lg:text-6xl uppercase leading-[0.95] tracking-tight">
            {t("getstarted.heading_line1")}{" "}
            <span className="text-[#FFEA00]">{t("getstarted.heading_line2_accent")}</span>
          </h2>
          <p className="mt-5 font-mono text-sm md:text-base text-[#A3A3A3] max-w-2xl mx-auto leading-relaxed">
            {t("getstarted.subline")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {(Array.isArray(steps) ? steps : []).map((step, i) => {
            const Icon = STEP_ICONS[i] || Download;
            return (
              <div
                key={i}
                data-testid={`getstarted-step-${i + 1}`}
                className="relative border-2 border-[#1f1f1f] bg-[#0a0a0a] p-6 md:p-8 hover:border-[#FFEA00]/60 transition-colors group"
              >
                <div className="absolute -top-px -right-px w-3 h-3 bg-[#FFEA00]" />
                <div className="flex items-start justify-between mb-4">
                  <span className="font-display font-bold text-[#FFEA00] text-5xl md:text-6xl leading-none tracking-tight">
                    {step.num}
                  </span>
                  <span className="w-12 h-12 border-2 border-[#FFEA00] bg-[#FFEA00]/[0.06] flex items-center justify-center group-hover:bg-[#FFEA00] transition-colors">
                    <Icon className="w-6 h-6 text-[#FFEA00] stroke-[2] group-hover:text-black transition-colors" />
                  </span>
                </div>
                <h3 className="font-display font-bold text-white text-xl md:text-2xl uppercase tracking-tight leading-tight mb-3">
                  {step.title}
                </h3>
                <p className="text-sm md:text-base text-[#A3A3A3] leading-relaxed">
                  {step.description}
                </p>
                {i < 2 && (
                  <div className="hidden md:block absolute top-1/2 -right-3 -translate-y-1/2 z-10">
                    <div className="w-6 h-6 border-2 border-[#FFEA00] bg-[#050505] rotate-45" />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
